<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Kart Numarası</label>
            <input class="form-control" v-model="value.CardNumber" placeholder="Kart Numarası"/>
        </div>
        <div class="col-12">
            <label class="form-label">Referans Kodu</label>
            <input class="form-control" v-model="value.RefCode" placeholder="Referans Kodu"/>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    }
}
</script>